import request from '@/util/request';
// 获取列表
export const getPageList = (params, options) =>
    request.get('/api/v4ward/contract/permission/page', Object.assign({}, options, { params }));

//新增

export const save = (params, options) =>
request.post('/api/v4ward/contract/permission/save', params, options)



//修改
export const remove = (id) =>
    request.post('/api/v4ward/contract/permission/remove?id='+id);

//删除
export const update = (params, options) =>
request.post('/api/v4ward/contract/permission/update', params, options)


export const getBisDictData = (params, options) =>
    request.get('/api/v4ward/projectDict/dictionary', Object.assign({}, options, { params }));